import React from 'react';
import { connect } from 'react-redux';
import { withTranslation } from 'react-i18next';
import CircularProgress from '@material-ui/core/CircularProgress';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import Paper from '@material-ui/core/Paper';
import { withStyles } from '@material-ui/core/styles';

import _cloneDeep from 'lodash/cloneDeep';
import _assign from 'lodash/assign';
import CheckIcon from '@material-ui/icons/Check';
import { green } from '@material-ui/core/colors';
import LeadsActions from '../../Redux/LeadsRedux';
import LayoutStyles from '../../Components/Layout/Styles/LayoutStyles';

type Props = {
  classes: Object,
  match: Object,
  updateLead: Function,
  isFetching: Boolean,
  error: Object,
  t: Function,
};

const styles = () => ({
  layout: LayoutStyles.centered400Layout,
  paper: LayoutStyles.centered400Paper,
  confirmed: {
    color: green[200],
    fontSize: 40,
  },
});

class QuickAction extends React.Component<Props> {
  componentDidMount() {
    const {
      match: {
        params: { action, id },
      },
    } = this.props;

    switch (action) {
      case 'accept':
        return this.validateResponsible({ id });
      case 'reject':
        return this.rejectResponsible({ id });
      default:
        return null;
    }
  }

  renderIsLoading = () => {
    const { t } = this.props;
    return (
      <>
        <CircularProgress />
        <Typography>{t('APP.QUICK_ACTION.DOING')}</Typography>
      </>
    );
  };

  renderIsDone = () => {
    const { classes, t } = this.props;

    return (
      <>
        <CheckIcon className={classes.confirmed} />
        <Typography>{t('APP.QUICK_ACTION.DONE')}</Typography>
      </>
    );
  };

  validateResponsible = lead => {
    const { updateLead } = this.props;
    const updatingLead = _assign(_cloneDeep(lead), { validated: true });

    updateLead(updatingLead);
  };

  rejectResponsible = lead => {
    const { updateLead } = this.props;
    const updatingLead = _assign(_cloneDeep(lead), { responsible_id: null });

    updateLead(updatingLead);
  };

  renderError = () => <Typography>KC</Typography>;

  render() {
    const { classes, isFetching, error } = this.props;

    return (
      <>
        <Grid container className={classes.layout}>
          <Paper className={classes.paper}>
            {isFetching && this.renderIsLoading()}
            {error && this.renderError()}
            {!isFetching && !error && this.renderIsDone()}
          </Paper>
        </Grid>
      </>
    );
  }
}

const mapStateToProps = state => ({
  isFetching: state.leads.isFetching.updateFamilyLead,
  error: state.leads.errors.updateFamilyLead,
});

const mapDispatchToProps = dispatch => ({
  updateLead: lead => dispatch(LeadsActions.updateFamilyLeadRequest(lead)),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(withStyles(styles)(withTranslation()(QuickAction)));
